var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#2DC071"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2957 10.2043C24.3604 10.269 24.4118 10.3457 24.4469 10.4302C24.4819 10.5147 24.5 10.6053 24.5 10.6968C24.5 10.7883 24.4819 10.8789 24.4469 10.9634C24.4118 11.0479 24.3604 11.1246 24.2957 11.1893L14.5578 20.9271C14.4932 20.9919 14.4164 21.0433 14.3319 21.0783C14.2474 21.1134 14.1568 21.1314 14.0654 21.1314C13.9739 21.1314 13.8833 21.1134 13.7988 21.0783C13.7143 21.0433 13.6375 20.9919 13.5729 20.9271L8.70398 16.0582C8.57337 15.9276 8.5 15.7504 8.5 15.5657C8.5 15.381 8.57337 15.2039 8.70398 15.0733C8.83459 14.9427 9.01173 14.8693 9.19644 14.8693C9.38115 14.8693 9.55829 14.9427 9.6889 15.0733L14.0654 19.4511L23.3107 10.2043C23.3754 10.1396 23.4521 10.0882 23.5366 10.0531C23.6211 10.018 23.7117 10 23.8032 10C23.8947 10 23.9853 10.018 24.0698 10.0531C24.1543 10.0882 24.231 10.1396 24.2957 10.2043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 11,
    fill: "white",
    transform: "translate(8 10)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check_green.0168b12f84ed41e24d1ad27de2c95850.svg";
export { ForwardRef as ReactComponent };